import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { h5, paragraphMedium, paragraphMicro, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.section `
  --bgColor: ${brand.white};
  --fgColor: ${brand.black};

  background-color: var(--bgColor);
  color: var(--fgColor);
  padding: ${fluid(24, 48)} ${fluid(30, 80)} ${fluid(40, 48)};

  @media ${from(Device.TabletLarge)} {
    --bgColor: ${brand.green};
    --fgColor: ${brand.white};

    margin: 40px;
  }
`;
const Title = styled.h3 `
  ${h5}

  text-align: center;

  @media ${until(Device.MobileLarge)} {
    margin-left: auto;
    margin-right: auto;
    max-width: 190px;
  }
`;
const Inner = styled.div `
  display: grid;
  grid-template-columns: 1fr;

  @media ${from(Device.TabletLarge)} {
    column-gap: 84px;
    grid-template-columns: repeat(2, 1fr);
  }
`;
const Content = styled.p `
  ${paragraphMedium}
`;
const ContentSmall = styled.p `
  ${paragraphMicro}
`;
const Label = styled.label `
  ${paragraphSmall}
  ${fonts.brandonGrotesque.medium}

  display: block;
  margin: 0 0 8px;
`;
const Value = styled.output `
  ${paragraphMedium}
  ${fonts.brandonGrotesque.bold}

  display: block;
  font-variant-numeric: tabular-nums;
  margin: 0 0 32px;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-position: under;
`;
const RangeSlider = styled.input `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
`;
const CtaWrapper = styled.div `
  display: flex;
  grid-column: 1 / span 2;
  justify-content: center;
  margin: 32px 0 0;
`;
const DataTable = styled.dl `
  ${paragraphSmall}

  display: grid;
  column-gap: 16px;
  row-gap: 16px;
  grid-template-columns: 1fr auto;
  margin: 0;
  position: relative;

  [data-headline] {
    ${fonts.brandonGrotesque.medium}

    margin: 0 0 8px;
  }

  dt {
    text-align: left;
  }

  dd {
    ${fonts.brandonGrotesque.medium}

    text-align: right;

    &[data-headline] {
      ${paragraphMedium}
      ${fonts.brandonGrotesque.bold}

      margin: 0 0 8px;
      text-decoration: underline;
      text-decoration-thickness: 2px;
      text-underline-position: under;
    }
  }
`;
const CalculatorStyles = {
    Container,
    Content,
    ContentSmall,
    CtaWrapper,
    DataTable,
    Inner,
    Label,
    RangeSlider,
    Title,
    Value,
};
export default CalculatorStyles;
